import { Component, OnInit } from '@angular/core';
import { VernostServiceService } from "../../../services/vernost-service.service";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: 'app-hide-ancillaries-code',
  templateUrl: './hide-ancillaries.component.html',
  styleUrls: ['./hide-ancillaries.component.css'],
  providers: [DatePipe]
})
export class HideAncillaries implements OnInit {

  actionmode: string = "Seacrh";
  showList: boolean = false;
  active_msg = "";
  viewRecord: any = [];
  nameExist: boolean = false;
  disableCode: boolean = false;
  loader: boolean = false;
  activeStatus = "1";
  isActive: boolean = false;
  screentitle: string = "Enable/Disable Ancillaries";
  screen_details: any = [];
  searchRecord: any = [];
  search_details: any = [];
  ancillariesName: any = "";
  activeObj = {};
  midType: any = [];
  searchlist: boolean = false;
  uid = "";
  statusvalue: boolean = false;
  traveltype: boolean = false;
  ancillariestype: boolean = false;
  formFactorType: boolean = false;
  midname: boolean = false;
  airlineData: any = [];
  ancillariesDataUba: any = [];
  ancillariesDataUbr: any = [];
  ancillariesDataBoth: any = [];
  platformData: any = [];
  // filteredairlineData:any=[];
  searchAncillariesRuleList: any = [];
  editFlag: boolean = false;

  //new
  dropdownSettings = {};
  dropdownPlatformSettings = {};
  constructor(private vernostService: VernostServiceService, private datePipe: DatePipe, private toastr: ToastrService) { }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'SSR_CODE',
      textField: 'SSR_TYPE',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.dropdownPlatformSettings = {
      singleSelection: false,
      idField: 'FORM_FACTOR_CATEGORY_CODE',
      textField: 'FORM_FACTOR_CATEGORY',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
    this.editFlag = false;
    this.screen_details.travelType = 0;
    this.screen_details.midName = 0;
    this.screen_details.midName = 0;
    this.screen_details.ID = 0;
    this.uid = localStorage.getItem('uid');
    this.getDropdown();
    this.ancillariesDataUba = [{ "SSR_TYPE": "MEAL", "SSR_CODE": "M" },
    { "SSR_TYPE": "BAGGAGE", "SSR_CODE": "B" },
    { "SSR_TYPE": "SEAT", "SSR_CODE": "S" },
    { "SSR_TYPE": "LOUNGE", "SSR_CODE": "L" },
    { "SSR_TYPE": "COMBO", "SSR_CODE": "C" }];

    this.ancillariesDataUbr = [{ "SSR_TYPE": "MEAL", "SSR_CODE": "M" },
    { "SSR_TYPE": "BAGGAGE", "SSR_CODE": "B" },
    { "SSR_TYPE": "SEAT", "SSR_CODE": "S" },
    { "SSR_TYPE": "LOUNGE", "SSR_CODE": "L" }];

    this.ancillariesDataBoth = [{ "SSR_TYPE": "MEAL", "SSR_CODE": "M" },
    { "SSR_TYPE": "BAGGAGE", "SSR_CODE": "B" },
    { "SSR_TYPE": "SEAT", "SSR_CODE": "S" },
    { "SSR_TYPE": "LOUNGE", "SSR_CODE": "L" },
    { "SSR_TYPE": "COMBO (UBA)", "SSR_CODE": "C" }];

    this.getPlatformData();
  }
  getPlatformData() {
    this.vernostService.getPlatformData().subscribe(response => {
      var platFormDataArray = [];
      var finalData = [];
      if (response["data"]) {
        //this.platformData = response["data"];
        platFormDataArray = response["data"];
        platFormDataArray.forEach((ele) => {
          if (ele.FORM_FACTOR_CATEGORY_CODE != 'A') {
            finalData.push(ele);
          }
        })
        this.platformData = finalData;
        // this.screen_details.platform = "A";
      }
    })
  }
  getDropdown() {
    this.vernostService.getDropdown().subscribe(response => {
      this.midType = response["mid_type"];
      this.midType.push({ "ID": 3, "MID_NAME": "Both", "RAZOPPAY_MID": "" })
      let tempData = this.midType[3];
      this.midType[3] = this.midType[0];
      this.midType[0] = tempData;

    })

  }





  addForm() {
    this.clearAll();
    this.editFlag = false;
    this.actionmode = "Add";
    this.showList = false;

  }

  searchForm() {
    this.actionmode = "Search";
    this.clearAll();
    this.searchRecord = [];
    this.searchlist = false;

  }


  validateFields() {



    if (this.screen_details.midName == 0) {
      this.midname = true;
    } else {
      this.midname = false;
    }


    if (this.screen_details.travelType == 0) {
      this.traveltype = true;
    } else {
      this.traveltype = false;
    }
    if (this.screen_details.selectedAncillaries.length > 0) {
      this.ancillariestype = false;
    } else {
      this.ancillariestype = true;
    }
    if (this.screen_details.platform.length > 0) {
      this.formFactorType = false;
    } else {
      this.formFactorType = true;
    }


    if (!this.midname && !this.traveltype) {


      return true;
    } else {
      // console.log("isinvalidvalidCode=",isinvalidvalidCode);
      return false;
    }

  }


  submitdata() {
    console.log("this.screen_details>>>", this.screen_details);

    var isvalid = this.validateFields();
    console.log("isvalid=", isvalid);

    if (isvalid) {
      console.log(this.screen_details);
      var obj = {
        uid: this.uid,
        midName: this.screen_details.midName,
        travelType: this.screen_details.travelType,
        status: this.activeStatus,
        ancillariesDataUba: this.screen_details.selectedAncillaries,
        platform: this.screen_details.platform,
        ID: ""
      }

      console.log("obj finals here=", JSON.stringify(obj));
      if (this.actionmode == "Add") {
        this.editFlag = false;
        this.vernostService.insertAncillaries(obj).subscribe(response => {

          if (response["result"]["status"]) {
            this.clearAll();
            document.getElementById("errs").innerHTML = "Record Inserted Successfully";


          } else {


            document.getElementById("errs").innerHTML = " " + response["msg"] + " ";
          }
        })




      } else {
        this.editFlag = true;
        obj.ID = this.screen_details.ID;
        this.vernostService.editAncillaries(obj).subscribe(response => {
          if (response["status"]) {
            //this.toastr.success("Record Updated Successfully ");
            document.getElementById("errs").innerHTML = "Record Updated Successfully";
            // this.clearAll();

          } else {
            //this.toastr.error("Record Update Failed ");
            document.getElementById("errs").innerHTML = "Rule is already configured.";
          }
        })


      }
    }
  }

  checkData() {
    var isvalid = this.validateFields();
    if (isvalid) {
      var obj = {
        uid: this.uid,
        midName: this.screen_details.midName,
        travelType: this.screen_details.travelType,
        status: this.activeStatus,
        ancillariesDataUba: this.screen_details.selectedAncillaries,
        platform: this.screen_details.platform,
        ID: ""
      }
      if (this.actionmode == "Add") {
        this.editFlag = false;
        this.vernostService.checkAncillariesRule(obj).subscribe(response => {
          if (response["status"]) {
            // show pop-up
            document.getElementById("openModalButton").click()
          } else {
            // No pop-up
            this.submitdata();
          }
        })

      } else {
        this.editFlag = true;
        // show pop-up
        document.getElementById("openModalButton").click()
      }
    }
  }

  clearAll() {
    this.clearmidname();
    this.cleartraveltype();
    this.onPlatFormSelectAll("");
    this.onSelectAll("");
    this.screen_details.midName = "0";
    this.screen_details.travelType = "0";
    this.activeStatus = "1";
    this.screen_details.selectedAncillaries = ""
    this.screen_details.platform = "";
    document.getElementById("errs").innerHTML = "";
  }


  showFormData(obj, flag) {
    if (flag == 1) {

      this.viewRecord = [obj];

    } else {
      this.editFlag = true;
      console.log("obj=", JSON.stringify(obj));
      this.actionmode = "Edit";
      this.screen_details.ID = obj.ID;
      this.screen_details.midName = obj.MID_TYPE_ID;
      this.screen_details.travelType = obj.JOURNEY_TYPE_CODE;
      this.activeStatus = String(obj.IS_ACTIVE);
      //    this.screen_details.platform = obj.FORM_FACTOR_CATEGORY_CODE;
      var airlineData = [];
      var ancillariesData = [];
      var platforms = []
      this.searchAncillariesRuleList.forEach(ele1 => {
        if (ele1.ID == obj.ID) {
          var ancillaries = this.ancillariesDataUba.filter(a => (a.SSR_TYPE == ele1.SSR_TYPE));
          var platForm = this.platformData.filter(a => (a.FORM_FACTOR_CATEGORY_CODE == ele1.FORM_FACTOR_CATEGORY_CODE));
          if (ancillaries.length > 0) {
            ancillariesData.push({
              "SSR_TYPE": ancillaries[0].SSR_TYPE,
              "SSR_CODE": ancillaries[0].SSR_CODE
            })
          }
          if (platForm.length > 0) {
            platforms.push({
              "FORM_FACTOR_CATEGORY": platForm[0].FORM_FACTOR_CATEGORY,
              "FORM_FACTOR_CATEGORY_CODE": platForm[0].FORM_FACTOR_CATEGORY_CODE
            })
          }
        }
        this.screen_details.selectedAncillaries = ancillariesData;
        this.screen_details.platform = platforms
      });
    }


  }

  searchData() {
    this.loader = true;

    var dsName = this.ancillariesName;
    if (dsName == "") {
      dsName = undefined;
    }
    var obj = {
      ancillariesName: dsName,
    };
    this.vernostService.searchAncillariesRule(obj).subscribe(response => {
      this.loader = false;
      this.searchAncillariesRuleList = response["result"];
      this.searchRecord = this.SortData(this.searchAncillariesRuleList);
      if (this.searchRecord.length > 0) {
        this.searchlist = true;
        document.getElementById("errs").innerHTML = "";
      } else {
        this.searchlist = false;
        document.getElementById("errs").innerHTML = "Record Not Found ";
      }
    })


  }

  SortData(list) {
    let finalData = [];
    list.forEach(ele => {
      var airline = this.airlineData.filter(a => a.AIRLINE_CODE == ele.AIRLINE_CODE);
      ele.AIRLINES = airline.length > 0 ? airline[0].AIRLINE_NAME : null;
      ele.AIRLINE_NAME = airline.length > 0 ? airline[0].AIRLINE_NAME : null;

    });

    for (let i = 0; i < list.length; i++) {
      let hasValue = false;
      if (i == 0) {
        finalData.push(list[i]);
      } else {
        for (let j = 0; j < finalData.length; j++) {
          if (finalData[j].ID == list[i].ID) {
            hasValue = true;
          }
        }
        if (hasValue == false) {
          finalData.push(list[i]);
        }
      }
    }
    finalData.forEach(ele1 => {
      list.forEach(ele2 => {
        if (ele1.ID == ele2.ID && ele1.AIRLINE_CODE != null && ele1.AIRLINES.indexOf(ele2.AIRLINES) == -1) {
          ele1.AIRLINES += "," + ele2.AIRLINES
        }
      });
    });
    return finalData;
  }


  clearmidname() {
    this.midname = false;

    if (!this.editFlag) {
      this.screen_details.selectedAncillaries = "";
      this.ancillariestype = false;
      if (this.screen_details.midName == 1) {
        this.ancillariesDataUba = this.ancillariesDataUbr;
      } else if (this.screen_details.midName == 3) {
        this.ancillariesDataUba = this.ancillariesDataBoth;
      } else {
        this.ancillariesDataUba = [{ "SSR_TYPE": "MEAL", "SSR_CODE": "M" },
        { "SSR_TYPE": "BAGGAGE", "SSR_CODE": "B" },
        { "SSR_TYPE": "SEAT", "SSR_CODE": "S" },
        { "SSR_TYPE": "LOUNGE", "SSR_CODE": "L" },
        { "SSR_TYPE": "COMBO", "SSR_CODE": "C" }];
      }
    }
  }

  cleartraveltype() {
    this.traveltype = false;
  }

  onItemSelect(item: any) {
    console.log(item);
    this.ancillariestype = false;
  }

  onSelectAll(items: any) {
    console.log(items);
    this.ancillariestype = false;
  }

  onPlatFormSelect(item: any) {
    console.log(item);
    this.formFactorType = false;
  }
  
  onPlatFormSelectAll(items: any) {
    console.log(items);
    this.formFactorType = false;
  }
}